import './App.scss';
import Home from './pages/Home';
import {Routes, Route, Navigate, useLocation} from 'react-router-dom';
import About from './pages/About';
import Services from './pages/Services';
import Treatments from './pages/Treatments';
import TreatmentDetail from './pages/TreatmentDetail';
import BlogsPage from './pages/BlogsPage';
import SingleBlog from './pages/SingleBlog/SingleBlog';
import Contactus from './pages/Contact/Contactus';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Analytics from './components/Analytics/Analytics';
// Geliştirme ortamında çerez bildirimi testleri için
import './utils/cookieConsentTest';
import { HelmetProvider } from 'react-helmet-async';
import React, { useEffect } from 'react';
import FabCallButton from './components/FabCallButton';
import FabWhatsAppButton from './components/FabWhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

// import MobileCompatibility from './components/MobileCompatibility/MobileCompatibility';
// import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';

// Rota yönlendirme bileşeni
const AppRoutes = () => {
  const { currentLang, setLanguage } = useLanguage();
  const location = useLocation();
  
  // URL'den dil kontrolü
  useEffect(() => {
    // URL /en ile başlıyorsa dili İngilizce olarak ayarla
    if (location.pathname.startsWith('/en') && currentLang !== 'en') {
      setLanguage('en');
    } 
    // URL /en ile başlamıyorsa dili Türkçe olarak ayarla
    else if (!location.pathname.startsWith('/en') && currentLang !== 'tr') {
      setLanguage('tr');
    }
  }, [location, currentLang, setLanguage]);
  
  return (
    <>
      <Analytics />
      {/* <MobileCompatibility /> */}
      {/* <AnalyticsRouteTracker /> */}
      <Routes>
        {/* TR Routes - Öncelikli */}
        <Route path="/" element={<Home />} />
        <Route path="/tedaviler" element={<Treatments />} />
        <Route path="/tedavi/:slug" element={<TreatmentDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/singleservice" element={<Services />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog/:url" element={<SingleBlog />} />
        <Route path="/contact" element={<Contactus />} />
        
        {/* EN Routes - Sadece İngilizce içerik varsa */}
        <Route path="/en" element={<Home />} />
        <Route path="/en/treatments" element={<Treatments />} />
        <Route path="/en/treatment/:slug" element={<TreatmentDetail />} />
        <Route path="/en/about" element={<About />} />
        <Route path="/en/singleservice" element={<Services />} />
        <Route path="/en/blogs" element={<BlogsPage />} />
        <Route path="/en/blog/:url" element={<SingleBlog />} />
        <Route path="/en/contact" element={<Contactus />} />
        
        {/* Bilinmeyen rotaları ana sayfaya yönlendir - Türkçe öncelikli */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <Analytics />
          <ScrollToTop />
          <AppRoutes />
          <FabCallButton />
          <FabWhatsAppButton />
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

// ResizeObserver loop hatasını bastırmak için global error handler
if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
    }
  });
}

export default App;
